<div class="sales-report-header-row">
  <div class="sales-report-header-main">
    <div class="sales-report-header-title-row">
      <h2 class="sales-report-title">
        {{ 'cards.reports.sales_report.title' | translate: { retailer: retailerName } }}
      </h2>
      <span class="sales-report-date-range" *ngIf="dateFrom || dateTo">
        {{ dateFrom | formDate }} - {{ dateTo | formDate }}
      </span>
    </div>
  </div>

  <div class="sales-report-header-actions" aria-hidden="true">
    <div class="skeleton-segmented">
      <div class="skeleton-segment skeleton-segment--active">
        <span class="skeleton-pill skeleton-pill--sm"></span>
      </div>
      <div class="skeleton-segment">
        <span class="skeleton-pill skeleton-pill--sm"></span>
      </div>
    </div>
    <div class="skeleton-icon-btn"></div>
  </div>
</div>

<div class="skeleton-content" aria-busy="true">
  <div class="skeleton-table">
    <div class="skeleton-products">
      <div class="skeleton-products-header">
        <span class="sort-az-icon"></span>
      </div>
      <div class="skeleton-product-row" *ngFor="let row of rows">
        <div class="skeleton-product-info">
          <span class="skeleton-product-image"></span>
          <span class="skeleton-product-name"></span>
        </div>
        <div class="skeleton-product-meta">
          <div class="skeleton-product-meta-row">
            <span class="skeleton-pill skeleton-pill--md"></span>
            <span class="skeleton-pill skeleton-pill--sm"></span>
          </div>
          <div class="skeleton-product-meta-row">
            <span class="skeleton-pill skeleton-pill--xs"></span>
            <span class="skeleton-pill skeleton-pill--xxs"></span>
          </div>
        </div>
      </div>
    </div>

    <div class="skeleton-days">
      <div class="skeleton-days-header">
        <div class="skeleton-day-header" *ngFor="let day of days">
          <span class="skeleton-pill skeleton-pill--day"></span>
        </div>
      </div>
      <div class="skeleton-day-row" *ngFor="let row of rows">
        <div class="skeleton-day-cell" *ngFor="let day of days">
          <span class="skeleton-bar skeleton-bar--short"></span>
          <span class="skeleton-bar skeleton-bar--tall"></span>
        </div>
      </div>
    </div>
  </div>

  <div class="skeleton-footer">
    <div class="skeleton-footer-zoom">
      <div class="skeleton-zoom-block">
        <span class="skeleton-icon"></span>
        <span class="skeleton-pill skeleton-pill--zoom"></span>
        <span class="skeleton-icon"></span>
      </div>
      <div class="skeleton-icon-btn"></div>
    </div>
    <div class="skeleton-footer-paging">
      <div class="skeleton-paging-group">
        <span class="skeleton-pill skeleton-pill--xxs"></span>
        <span class="skeleton-pill skeleton-pill--sm"></span>
      </div>
      <div class="skeleton-paging-group">
        <span class="skeleton-pill skeleton-pill--md"></span>
        <span class="skeleton-chevron"></span>
      </div>
      <div class="skeleton-paging-nav">
        <span class="skeleton-icon-btn"></span>
        <span class="skeleton-icon-btn"></span>
        <span class="skeleton-icon-btn"></span>
        <span class="skeleton-icon-btn"></span>
      </div>
    </div>
  </div>
</div>
